/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarTasksGroup } from '../calendar-tasks-group';
import { Time } from '../../../types/time.type';

export class HourSelectionEvent {
  public start: Time;
  public end: Time;
  public event: MouseEvent;
  public resource: CalendarTasksGroup;

  constructor(
    selection: { start: Time; end: Time; resource?: CalendarTasksGroup },
    event: MouseEvent,
  ) {
    this.start = selection.start;
    this.end = selection.end;
    this.event = event;
    this.resource = selection.resource;
  }

  public getStart(): Date {
    return new Date();
  }

  public getEnd(): Date {
    return undefined;
  }

  public getResource(): CalendarTasksGroup {
    return this.resource;
  }
}
